var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 433,
    viewBox: "0 0 478 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436 2H42C19.9086 2 2 19.9086 2 42V391C2 413.091 19.9086 431 42 431H436C458.091 431 476 413.091 476 391V42C476 19.9086 458.091 2 436 2Z",
    stroke: "url(#paint0_linear_12_718)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_718",
    x1: 239,
    y1: 431,
    x2: 239,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0480E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderDotted);
export default __webpack_public_path__ + "static/media/border-dotted.e9426abdcc657dc1bcc58e002b5f265b.svg";
export { ForwardRef as ReactComponent };